import { atom } from "jotai";

import { type ModificationRequestFormSchema } from "@/pages/ModificationRequestPage/ModificationRequestForm.schema";

// Global atom holding the current modification request form state
export const modificationRequestFormAtom =
  atom<ModificationRequestFormSchema>();

// Flag to prevent double-fetching
export const isModificationRequestFormInitializedAtom = atom(false);
